<template lang="pug">
v-main
  v-container
    v-card
      v-toolbar.elevation-0
        v-toolbar-title Create Blocked Email
      v-divider
      v-card-text
        v-form.my-2
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Domain 
            v-col(cols="5")
              v-text-field(
                v-model="domain",
                label="Domain",
                :rules="[rules.required, rules.validDomain]",
              )
            
          v-card-actions.my-8
            v-btn.custom__padding-btn(@click="$router.push('/blocked-email')") Back
            v-btn.custom__padding-btn(
              :disabled="!formIsValid",
              color="blue-secondary",
              @click="create()"
            ) Create

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default {
  data: () => ({
    domain: "",
    rules: {
      required: (value) => !!value || "This field is required.",
      validDomain: (value) => {
        if (!domainRegex.test(value)) {
          return "Invalid input. Example of valid input : @gmail.com";
        }
      }
    },
    overlay: false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid() {
      return this.domain && domainRegex.test(this.domain);
    },
  },
  methods: {
    create() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      let formData = new FormData();
      formData.append("domain", this.domain);

      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/blocked-email/create`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
            domain: this.domain
        },
      };

      axios(config)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$toasted.success("Success create data", {
              icon: "check_circle",
            });
            return this.$router.push("/blocked-email");
          }
        })
        .catch((message) => {
          this.overlay = false;
          this.showError(message);
        });
    },
    showError(message) {
      this.$toasted.error(message.response.data.message, { icon: "error" });
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div.v-input__prepend-outer {
  display: none !important;
}

div.v-image__image {
  width: 150px;
  height: 150px;
}

div.v-responsive__sizer {
  padding-bottom: 0;
}

.v-image {
  width: 150px;
  height: 150px;
}
</style>